import { render } from "./TeachingPlanTransferRuleTab.vue?vue&type=template&id=157cf1e4&scoped=true&ts=true"
import script from "./TeachingPlanTransferRuleTab.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanTransferRuleTab.vue?vue&type=script&lang=ts"

import "./TeachingPlanTransferRuleTab.vue?vue&type=style&index=0&id=157cf1e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157cf1e4"]])

export default __exports__